import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FreudButtonModule, FreudLoaderModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { ExportRoutes } from 'modules/exports/routes/export.routes';
import { RecaptchaModule } from 'ng-recaptcha';

import { PromptuaryExportComponent } from './promptuary-export.component';

@NgModule({
	declarations: [PromptuaryExportComponent],
	imports: [
		CommonModule,
		RouterModule.forRoot(ExportRoutes),
		TranslateModule,
		RecaptchaModule,
		FreudButtonModule,
		FreudLoaderModule,
	],
	exports: [PromptuaryExportComponent],
	providers: [],
})
export class PromptuaryExportModule {}
